// Generated by genversion.
export const version = '5.1237.0';
